
export default {
    POST: 'POST',
    PATH: 'PATH',
    QUERY: 'QUERY',
    OTHER: 'OTHER'
};



// WEBPACK FOOTER //
// ./services/common/parameterApplications.js